import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

@Component({
    selector: 'app-rate-detail',
    templateUrl: './rate-detail.component.html',
    styleUrls: ['./rate-detail.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class RateDetailComponent {
    @Input() rate: any;
    public copyRate;

    constructor(
        public activeModal: NgbActiveModal
    ) { }

    ngOnInit() {
        this.copyRate = JSON.parse(JSON.stringify(this.rate));
        if (this.rate && this.rate.infoDetails && this.rate.infoDetails.length && this.rate.offers && this.rate.offers.length) {
            this.copyRate.infoDetails.map(item => item.description = item.description.replace(this.rate.data, '<strike>' + this.rate.data + '</strike> ' + this.rate.offers[0].data));
        }
    }

    getAmData(rate: any): string {
        let data = rate.data;

        if (rate.offers && rate.offers.length > 0) {
            const today = moment();
            const expiredDate = moment(rate.offers[0].expired_date);

            if (expiredDate.isSameOrAfter(today)) {
                data = '<strike>' + rate.data + '</strike> ' + rate.offers[0].data;
            }
        }

        return data;
    }
}
